import LOGO1 from "./svgs/LOGO-PURPLE.svg";
import LOGO2 from "./svgs/LOGO-YALA-PURPLE.svg";
import LOGO_BLACK from "./svgs/LOGO-YALA-BLACK.svg";
import LoginImage from "./svgs/animation.svg";
import LoginHeaderImage from "./images/purpleBGUP.png";
import XIcon from "./svgs/x.svg";
import Clock from "./svgs/shaon.svg";
import Cash from "./svgs/Cash.svg";
import CreditCard from "./svgs/CreditsCard.svg";
import PURPLELOGO from "./images/Purple-logo.jpg";
import YalaIcon96 from "./96@2x.png";
import YalaIcon512 from "./yala512@2x.png";
import YalaIcon1024 from "./yala1024@2x.png";

const IphoneSound = require("./sounds/iphone.mp3");

enum Colors {
  LIGHTERPURPLE = "#7a14ad",
  PURPLE = "#520989",
  WHITE = "#f8f7ff",
  GREEN = "#4fddc6",
}

export {
  LOGO1,
  LOGO2,
  LOGO_BLACK,
  LoginHeaderImage,
  LoginImage,
  XIcon,
  Clock,
  Colors,
  Cash,
  CreditCard,
  IphoneSound,
  PURPLELOGO,
  YalaIcon96,
  YalaIcon512,
  YalaIcon1024,
};
